console.log('sidebar-az.js');


class DrinkSelectorPopup extends HTMLElement {
  static observedAttributes = ["collection"];

  bodyClassActive = "drink-selector-active";
  imagesContainer;
  productsListEl;
  drinkSelectorCloser;
  filterButtons;
  letterFilterBtns;
  productsCount;
  products = [];
  productsInGroups = [];
  resultsPerPage = 250;
  numPages;
  selectedCollection = 'Whiskies';

  constructor() {
    super();
    console.log('POPUP CONSTRUCTOR');
    
    this.imagesContainer = this.querySelector(".dsp-images");
    this.productsListEl = this.querySelector(".dsp-products-list");
    this.drinkSelectorCloser = this.querySelector(".drink-selector-closer");
    this.filterButtons = document.querySelectorAll(".dsp-filters button");
    this.letterFilterBtns = this.querySelectorAll(".letter-filters button");

    this.productsCount = this.getAttribute("data-products-count");
    this.numPages = Math.ceil(this.productsCount / this.resultsPerPage);
  }

  connectedCallback() {
    console.log('POPUP CONNECT');
    
    this.getAndSetProducts();
    this.setupFilters();
    this.setupLetterFilters();

    this.drinkSelectorCloser.addEventListener("click", () => {
      document.body.classList.remove(this.bodyClassActive);
    });
  }

  attributeChangedCallback(name, from, to) {
    if (name == "collection") {
      this.filterButtons.forEach((element) => {
        this.selectedCollection = to;

        element.classList.remove("active");

        if (element.value == to) {
          element.classList.add("active");
        }
      });

      this.hideImage();
      this.filterProducts();
    }
  }

  filterProducts() {
    if (this.selectedCollection == "Whiskies") {
      this.productsListEl.classList.remove("filtered");
    } else {
      this.productsListEl.classList.add("filtered");
    }

    this.productsListEl.querySelectorAll("dd").forEach((element) => {
      element.classList.remove("disabled");

      if (this.selectedCollection != "Whiskies") {
        if (!element.dataset.tags.includes(this.selectedCollection)) {
          element.classList.add("disabled");
        }
      }
    });

    let firstEl = this.productsListEl.querySelector("dd:not(.disabled)");
    if (firstEl) {
      this.productsListEl.scrollTo({
        top: firstEl.offsetTop - 150,
        behavior: "smooth"
      })
    }
  }

  setupFilters() {
    let filterBtn;

    for (let i = 0; i < this.filterButtons.length; i++) {
      filterBtn = this.filterButtons[i];

      filterBtn.addEventListener("click", (e) => {
        this.setAttribute("collection", e.target.value);
      });
    }
  }

  setupLetterFilters() {
    let filterBtn;

    for (let i = 0; i < this.letterFilterBtns.length; i++) {
      filterBtn = this.letterFilterBtns[i];

      filterBtn.addEventListener("click", (e) => {
        console.log(e.target.value);

        const dt = document.querySelector('dt[data-letter="' + e.target.value + '"]');
        if (null != dt) {
          dt.scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }

  getAndSetProducts() {
    async function getProducts(page = 1, limit = 80) {
      const response = await fetch(`/collections/Whiskies?view=json&limit=${limit}&page=${page}`);
      return response.json();
    }

    let promises = [];

    for (let i = 1; i <= this.numPages; i++) {
      promises.push(new Promise((resolve, reject) => {
        getProducts(i, this.resultsPerPage)
          .then((data) => {
            this.products = [...this.products, ...data.products];
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          })
      }))
    }

    Promise.all(promises).then(() => {
      let titleA;
      let titleB;
      let juniorTitle;
      let firstLetter;
    
      this.products.sort((a, b) => {
        titleA = a.title.replace(/^(The )/, "");
        titleB = b.title.replace(/^(The )/, "");
    
        return titleA.localeCompare(titleB);
      });
    
      this.products.forEach((prod) => {
        juniorTitle = prod.title.replace(/^(The )/, "");
        firstLetter = juniorTitle.charAt(0).toLowerCase();
    
        if (this.productsInGroups[firstLetter] === undefined) {
          this.productsInGroups[firstLetter] = [];
        }
    
        this.productsInGroups[firstLetter].push(prod);
      })
    
      this.renderProductsGroups();
    })
  }

  renderProductsGroups() {
    let dt;
    let groupProducts;

    for (const groupName in this.productsInGroups) {
      groupProducts = this.productsInGroups[groupName];

      dt = document.createElement("dt");
      dt.innerHTML = groupName;
      dt.dataset.letter = groupName;
      
      this.productsListEl.append(dt);
  
      let dd;
      let link;
  
      groupProducts.forEach((prod) => {
        if (prod.tags.indexOf("exclude_from_AZ_drawer") > -1) return;
        
        dd = document.createElement("dd");

        dd.dataset.tags = prod.tags;
        dd.dataset.productId = prod.id;
        dd.dataset.alternate_background = prod.alternate_bg_color;

        link = document.createElement("a");
        link.href = "/products/" + prod.handle + "/";
        link.innerHTML = prod.title;

        dd.append(link);

        dd.addEventListener("mouseenter", (e) => {
          if (e.target.classList.contains("disabled")) return;
          this.showImage(e.target.dataset.productId, e.target.dataset.alternate_background);
          /*
          let allItems = this.productsListEl.querySelectorAll("dd");
          allItems.forEach((item) => {
            item.classList.add("unhovered");
          });
          dd.classList.remove("unhovered");*/
        });

        dd.addEventListener("mouseleave", () => {
          this.hideImage();/*
          let allItems = this.productsListEl.querySelectorAll("dd");
          allItems.forEach((item) => {
            item.classList.remove("unhovered");
          });*/
        });
    
        this.productsListEl.append(dd);

        this.renderImageElement(prod);
      })
    }
  }

  showImage(productId, backgroundColor) {
    this.hideImage();
    this.imagesContainer.querySelector('img[data-product-id="' + productId + '"]').classList.add("active");
    this.imagesContainer.style.backgroundColor = backgroundColor;
  }

  hideImage() {
    const currentActive = this.imagesContainer.querySelector('img.active');
    if (currentActive) {
      currentActive.classList.remove("active");
      this.imagesContainer.style.backgroundColor = "";
    }
  }

  renderImageElement(product) {
    const imgEl = document.createElement("img");
    const prodImg = product.images[0];
    imgEl.src = prodImg;
    imgEl.dataset.productId = product.id;

    this.imagesContainer.append(imgEl);
  }
}

customElements.define("drink-selector-popup", DrinkSelectorPopup);

class DrinkSelectorOpener extends HTMLElement {
  bodyClassActive = "drink-selector-active";

  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      document.body.classList.toggle(this.bodyClassActive);
    });

    this.bgButton = document.querySelector('.drink-selector-opener__mobile-bg');
    
    window.addEventListener('scroll', this.toggleActive.bind(this));
    this.toggleActive();

  }

  toggleActive() {
    let firstSection = document.querySelector("main section");
    if (window.scrollY > firstSection.offsetHeight) {
      this.classList.add('drink-selector-opener--active');
      this.bgButton.classList.add('drink-selector-opener--active');
    } else {
      this.classList.remove('drink-selector-opener--active');
      this.bgButton.classList.remove('drink-selector-opener--active');
    }
  }
}

customElements.define("drink-selector-opener", DrinkSelectorOpener);
